import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import {
  apiURL,
  div,
  graphPercent,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalTransactionRanking = ({ params, titleSetter }) => {
  const { t } = useTranslation()
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('transaction_ranking'),
    params,
    'post'
  )

  if (data?.params && data?.params?.series_number) {
    titleSetter(
      t('generic.spa.results.transaction_ranking.material_number') +
        ' ' +
        data.params.series_number
    )
  }

  return (
    <div data-spa-type="transaction_ranking">
      <div className="spa-block-full mt-2">
        <div data-spa-result-for="transaction_ranking">
          {loading && <LoadingSpinner />}
          {data?.response.ranking && data?.response.ranking.length > 0 && (
            <>
              <div className="spa-block-full mt-1 mb-2 text-center">
                <i className="fa fa-signal fa-3x"></i>
                <br />
                {t('generic.spa.results.transaction_ranking.place')}
                &nbsp;
                {data?.response.ranking[0].ranking}
              </div>
              <div className="spa-block-full mb-2">
                <h4 className="mb-1">{data?.response.ranking[0].name}</h4>
                <strong>
                  {t('generic.spa.results.transaction_ranking.revenue')}
                </strong>
                &nbsp;
                {div(data?.response.ranking[0].umsatz)}
                <br />
                <strong>
                  {t(
                    'generic.spa.results.transaction_ranking.work_order_items'
                  )}
                </strong>
                &nbsp;
                {data?.response.ranking[0].positionen}
                <br />
                <strong>
                  {t('generic.spa.results.transaction_ranking.ranking')}
                </strong>
                &nbsp;
                {data?.response.ranking[0].ranking}
                <br />
              </div>
            </>
          )}
          {data?.response.liste.length > 0 && (
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  {data?.params?.internal === 'true' && <th>Name</th>}
                  {data?.params?.furniture === 'true' &&
                    data?.params?.cumulative === 'true' && (
                      <th>
                        {t(
                          'generic.spa.results.transaction_ranking.material_number'
                        )}
                      </th>
                    )}
                  <th>
                    {t('generic.spa.results.transaction_ranking.revenue')}
                  </th>
                  <th>
                    {t(
                      'generic.spa.results.transaction_ranking.work_order_items'
                    )}
                  </th>
                  <th style={{ width: '40%' }}>
                    {t('generic.spa.results.transaction_ranking.comparison')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.response.liste.map((liste, index) => (
                  <tr
                    key={index}
                    className={`${
                      parseInt(liste.kundennr) ===
                        parseInt(data?.params?.customer_number) &&
                      data?.params?.cumulative !== 'true'
                        ? 'font-weight-bold'
                        : ''
                    }`}
                  >
                    <td>{index + 1}</td>
                    {data?.params?.internal === 'true' && <td>{liste.name}</td>}
                    {data?.params?.furniture === 'true' &&
                      data?.params?.cumulative === 'true' && (
                        <td>
                          <>
                            {liste.matnr.length === 2 && (
                              <a
                                href="#"
                                onClick={() =>
                                  triggerModal({
                                    customer_number: liste.kundennr,
                                    series_number: liste.matnr,
                                    cumulative: false,
                                    furniture: true,
                                    status: true,
                                  })
                                }
                              >
                                {liste.matnr}
                              </a>
                            )}
                            {liste.matnr.length !== 2 && liste.matnr}
                          </>
                        </td>
                      )}
                    <td data-sort-method="dotsep">{div(liste.umsatz)}</td>
                    <td>{liste.positionen}</td>
                    <td>
                      <div
                        className="revenue-graph"
                        style={{
                          width: graphPercent(
                            liste.umsatz,
                            data?.response.liste[0].umsatz
                          ),
                        }}
                      ></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}

export default ModalTransactionRanking
